import React, { useState, useEffect } from 'react';
import AddEtnia from './AddEtnia';
import { Table, TableBody, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';
function GestionEtnias() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [etnias, setEtnias] = useState([]);
    const [editEtnia, setEditEtnia] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [etniaToDelete, setEtniaToDelete] = useState(null);
    const [dataChanged, setDataChanged] = useState(false); // Estado para controlar la recarga de datos
    const { user } = useUser();

    const fetchEtnias = async () => {
        try {
            const response = await fetch(`${server}/MgEtnias`);
            const data = await response.json();
            setEtnias(data.$values);
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Error al cargar las etnias: ' + error,
            });
        }
    };

    useEffect(() => {
        fetchEtnias();
    }, [dataChanged]);

    const handleNewEtnia = () => {
        fetchEtnias();
        setEditEtnia(null);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const filteredEtnias = etnias.filter(etnia => etnia.descripcion.toLowerCase().includes(searchQuery.toLowerCase()));

    const handleDeleteEtnia = async () => {
        if (etniaToDelete) {
            try {
                const username = ''+user.codigoUsuario+'/';

                const response = await fetch(`${server}/MgEtnias/${etniaToDelete.id}/${username}`, {
                     method: 'DELETE' 
                    });
                if (response.ok) {
                    setEtnias(etnias.filter(e => e.id !== etniaToDelete.id));
                    setDataChanged(prev => !prev); // Toggle para recargar datos
                    setDeleteDialogOpen(false);
                    Swal.fire({
                        icon: 'success',
                        title: 'Éxito',
                        text: 'etnia eliminada con éxito',
                    });                } else {
                    handleCloseDialog();

                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al eliminar la etnia: ' + error,
                });
            }
        }
    };

    const handleOpenDialog = (etnia) => {
        setEtniaToDelete(etnia);
        setDeleteDialogOpen(true);
    };
    return (
        <>
            <div className="x_title">

            </div>
            <div className="x_content">
                <br />
                <AddEtnia handleNewEtnia={handleNewEtnia} editEtnia={editEtnia} />
                <div className="ln_solid" />

                <h2>Etnias Existentes</h2>
                <div className="row">
                    <div className="col-md-6 col-sm-4 offset-md-3">
                        <TextField
                            fullWidth
                            variant="outlined"
                            label="Buscar etnia"
                            value={searchQuery}
                            onChange={handleSearchChange}
                            style={{ marginBottom: '20px' }}
                        />
                        <div className="table-responsive">
                            <TableContainer component={Paper}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Nombre de Etnia</TableCell>
                                            <TableCell align="right">Acciones</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredEtnias.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((etnia) => (
                                            <TableRow key={etnia.id}>
                                                <TableCell>{etnia.descripcion}</TableCell>
                                                <TableCell align="right">
                                                    <Button onClick={() => setEditEtnia(etnia)} color="primary" disabled={!tienePermiso('Editar Etnia')}>
                                                        Editar
                                                    </Button>
                                                    <Button onClick={() => handleOpenDialog(etnia)} color="secondary" disabled={!tienePermiso('Eliminar Etnia')}>
                                                        Eliminar
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={filteredEtnias.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                            <Dialog
                                open={deleteDialogOpen}
                                onClose={() => setDeleteDialogOpen(false)}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle id="alert-dialog-title">{"Eliminar Etnia"}</DialogTitle>
                                <DialogContent>
                                    <DialogContentText id="alert-dialog-description">
                                        ¿Estás seguro de que quieres eliminar esta etnia?
                                    </DialogContentText>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => setDeleteDialogOpen(false)} color="primary">
                                        Cancelar
                                    </Button>
                                    <Button onClick={handleDeleteEtnia} color="primary" autoFocus>
                                        Eliminar
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default GestionEtnias